import { headers, parseJSON } from '../../apiUtils';
import { arrayIsNotEmpty } from '../../utils';

export function fetchReasonsForContact() {
    const path = `/api/dataV3/reasons-for-contact`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchDomainValues() {
    const path = `/api/dataV3/domainValues`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchReasonsForContactForUser() {
    const path = `/api/dataV3/reasons-for-contact-for-user`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchChannels() {
    const path = `/api/dataV3/channels`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchCalibratedOnSurveyQuestions() {
    const path = `/api/dataV3/calibratedOn-surveyquestions`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchAgentsOfTeamsOfTheUser() {
    const path = `/api/dataV3/agents-of-user-teams`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchUserTeamsStats() {
    const path = `/api/dataV3/user-teams`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchLiveSurveys(selectedFilters) {
    let path = `/api/dataV3/live-surveys`;
    if (arrayIsNotEmpty(selectedFilters)) {
        const newArray = selectedFilters.map(obj => {
            return {
                domainValueId: obj.id,
                domainValueName: obj.value,
                domainId: obj.domainId
            };
        });
        const stringifySelectedFilters = JSON.stringify(newArray);
        path += `?selectedFilters=${stringifySelectedFilters}`;
    }
    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}